import { gql } from "@apollo/client";

const GET_VISITA_CD = gql`
query GetDatosVisitaCD($idVisita: Int!, $idEvaluacion: Int!) {
    visitaCD(idVisita: $idVisita, idEvaluacion: $idEvaluacion) {
        idVisitaCD
        listaDiagnostico {
          idItemDiagnostico
          idDiagnostico
          descripcionItemDiagnostico
          descripcionDiagnostico
        }
        alergias{
          idAlergia
          descripcionAlergia
          descripcionAlergiaOtro
        }
        enfermedadOncologica
        peso
        talla
        soporteNutricional
        examenFisico
        traqueostomia
        sondaVesical
        ostomia
        cateter
        sondaNasogastrica
        idComboVisitaValorKarnofsky
        idComboRIValorLansky

        infusionDrogas
        drogaAInfundir
        dosis
        frecuencia
        cumpleCriteriosIngreso
        infusionesPrevias
        cantidadInfusionesPrevias
        lugarInfusionesPrevias
        presentoReaccionesAdversas

        manejoHeridas
        idComboVisitaValorTipoHerida
        otrasHeridas
        localizacion
        idComboVisitaValorComplejidad
        indicacion
        idComboVisitaValorComplejas
        vac
        presionVAC
        idComboVisitaValorModoVAC

        tratamiento
        situacionActual
        requerimientosActuales

        adicionalesVisita{
            idVisita
            idComboRIValorReqAdicional
        }
    }
}`;

export const adaptVisitaCD = (data) => ({
  enfermedadOncologica: !!data?.enfermedadOncologica,
  idVisitaCD: data?.idVisitaCD,
  peso: data?.peso,
  talla: data?.talla,
  soporteNutricional: !!data?.soporteNutricional,
  examenFisico: data?.examenFisico,
  traqueostomia: !!data?.traqueostomia,
  sondaVesical: !!data?.sondaVesical,
  ostomia: !!data?.ostomia,
  cateter: !!data?.cateter,
  sondaNasogastrica: !!data?.sondaNasogastrica,
  idComboVisitaValorKarnofsky: data?.idComboVisitaValorKarnofsky,
  idComboRIValorLansky: data?.idComboRIValorLansky,
  diagnosticoCIE10: data?.listaDiagnostico?.map((x) => {
    return {
      codigoItem: x.idItemDiagnostico,
      codigo: x.idDiagnostico,
      descripcionItem: x.descripcionItemDiagnostico,
      descripcion: x.descripcionDiagnostico
    };
  }) || [],
  alergiasDatosClinicos: data?.alergias?.map((a) => a.idAlergia) || [],
  descripcionAlergiaOtro: data?.alergias?.find((a) => a.descripcionAlergia?.toLowerCase() === 'otros')?.descripcionAlergiaOtro || '',
  infusionDrogas: !!data?.infusionDrogas,
  drogaAInfundir: data?.drogaAInfundir,
  dosis: data?.dosis,
  frecuenciaDrogas: data?.frecuencia,
  cumpleCriteriosIngreso: data?.cumpleCriteriosIngreso,
  infusionesPrevias: !!data?.infusionesPrevias,
  cantidadInfusionesPrevias: data?.cantidadInfusionesPrevias,
  lugarInfusionesPrevias: data?.lugarInfusionesPrevias,
  presentoReaccionesAdversas: data?.presentoReaccionesAdversas,

  manejoHeridas: !!data?.manejoHeridas,
  idComboVisitaValorTipoHerida: data?.idComboVisitaValorTipoHerida,
  otrasHeridas: data?.otrasHeridas,
  localizacion: data?.localizacion,
  idComboVisitaValorComplejidad: data?.idComboVisitaValorComplejidad,
  indicacion: data?.indicacion,
  idComboVisitaValorComplejas: data?.idComboVisitaValorComplejas,
  vac: !!data?.vac,
  presionVAC: data?.presionVAC,
  idComboVisitaValorModoVAC: data?.idComboVisitaValorModoVAC,

  obsTratamiento: data?.tratamiento,
  obsSituacionActual: data?.situacionActual,
  obsRequerimientoActual: data?.requerimientosActuales,

  idComboRIValorReqAdicional: data?.adicionalesVisita?.map((av) => av.idComboRIValorReqAdicional) || []
});

export default GET_VISITA_CD;